import React, { useEffect, useState } from "react";
import "../weather/weather.css";

export const Weather = ({ weatherUrl }) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    fetch(weatherUrl)
      .then((response) => response.json())
      .then((json) => {
        setData(json);
      })
      .catch((err) => console.error("Weather API error:", err));
  }, [weatherUrl]);

  const currentCondition = data?.CurrentCondition;

  return (
    <div className="wCard">
      {!currentCondition ? (
        <div className="card-body">Loading...</div>
      ) : (
        <>
          <div className="card-body">{currentCondition.City}</div>
          <div>
            {currentCondition.RealFeelTemperature}&deg;
            <span>
              <img
                className="weather-icon"
                src={currentCondition.WeatherIconURL}
                alt={currentCondition.WeatherText || "Weather icon"}
              />
            </span>
          </div>
        </>
      )}
    </div>
  );
};
